import $ from "jquery";

function toggleitems(ctoggle) {
    $(".item .blog-inner, .portfolio-item").each(function (index) {
      $(this).css("animation-duration", function () {
        var randno = Math.random();

        return 0.5 + randno + "s";
      });
    });

    $(".active").removeClass("active");
    $(ctoggle).addClass("active");

    var $cat = $(ctoggle).attr("data-role");

    $(".team-container").toggleClass("load load1");

    if ($cat == "all") {
      $(".item").addClass("active");
    } else {
      $(".cat-" + $cat).addClass("active");
    }
  }

  var defaultcat = $(".toggle-container").attr("data-initial");


  $(".toggle").each(function () {

    var role = $(this).attr("data-role");

    if (role == defaultcat) {

      toggleitems(this);
    }
  });

  $(".toggle").click(function () {
    toggleitems(this);
  });

